/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useState, useEffect, useRef, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../../showTost';
import { addDoc, collection, doc, getDoc, onSnapshot, orderBy, query, setDoc } from 'firebase/firestore';
import { db } from '../../Firebase/firebase';
import dayjs from "dayjs";
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
const Chat = () => {

    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [input, setInput] = useState("");
    const [allChat, setAllChat] = useState([]);
    const [apiloading, setApiLoding] = useState("");

    const chatBoxBodyRef = useRef(null);

    const navigate = useNavigate();
    const Location = useLocation();

    const Userid = secureLocalStorage.getItem("Userid");

    useEffect(() => {
        if (chatBoxBodyRef.current) {
            chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
        }
    }, [allChat]);

    useEffect(() => {
        handleGetAllChat();
    }, []);

    const handleGetAllChat = () => {

        const chatRoomId = [Location.state.id, Userid].join("_");

        const messagesRef = collection(db, "UClapProChat_rooms", chatRoomId, "message");
        const messagesQuery = query(messagesRef, orderBy("timestamp", "asc"));

        const unsubscribe = onSnapshot(messagesQuery, (snapshot) => {

            const data = snapshot.docs.map((doc) => {
                const messageData = doc.data();
                const messageTime = messageData.timestamp?.toDate();

                return {
                    ...messageData,
                    formattedTime: messageTime
                };
            });
            setAllChat(data);
            setLoading(false);
        });

        return () => unsubscribe();

    }

    const handleSendMessage = async () => {

        if (apiloading) return;

        if (!input) {
            showToast({ title: t("Please write message !!"), id: "info" });
            return;
        }

        setApiLoding("send");

        const LoginData = secureLocalStorage.getItem("Logindata");
        const { name } = JSON.parse(LoginData);

        const chatRoomId = [Location.state.id, Userid].join("_");
        const userRef = doc(db, "UClapProChat_rooms", chatRoomId);
        const docSnapshot = await getDoc(userRef);
        const messageData = {
            message: input,
            reciverId: Location.state.id,
            senderName: name,
            senderId: Userid,
            timestamp: new Date(),
            status: "1",
        };

        if (docSnapshot.exists()) {
            await addDoc(collection(userRef, "message"), messageData);
        } else {
            await setDoc(userRef, { timestamp: new Date() });
            await addDoc(collection(userRef, "message"), messageData);
        }

        setInput('');
        setApiLoding("");
        handleSendNotification(name, input, Location.state.id);
    }

    const handleSendNotification = async (name, message, value) => {
        try {
            const res = await axios.post(`${BaseUrl}user_api/send`,
                {
                    title: name,
                    message: message,
                    partnerId: value
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );
        } catch (error) {
            console.error("Notification error:", error);
        }
    };

    const handleTimeFormat = (messageTime) => {
        if (!messageTime) return "No time available";
        const msgDate = new Date(messageTime);
        const timeStr = msgDate.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        return timeStr;
    };

    const handleKeyDown = (e) => {
        if (e.key == "Enter") {
            handleSendMessage();
        }
    }

    if (loading) {
        return (<div className="w-full h-[calc(100vh-85px)] bg-white z-[777] fixed flex items-center justify-center">
            <div className="loader"></div>
        </div>)
    }

    return (
        <div className="chat_page">
            <div className="width_container">
                <div className="chat_box">

                    <div className="bg-white shadow px-[20px] py-[8px] rounded-[10px]">
                        <div className="flex items-center gap-[15px]">
                            <button onClick={() => navigate(-1)}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.7501 12C20.7501 12.414 20.4141 12.75 20.0001 12.75H5.81115L8.53112 15.47C8.82412 15.763 8.82412 16.238 8.53112 16.531C8.38512 16.677 8.19309 16.751 8.00109 16.751C7.80909 16.751 7.61706 16.678 7.47106 16.531L3.47106 12.531C3.40206 12.462 3.3472 12.3791 3.3092 12.2871C3.2332 12.1041 3.2332 11.8971 3.3092 11.7141C3.3472 11.6221 3.40206 11.539 3.47106 11.47L7.47106 7.46999C7.76406 7.17699 8.2391 7.17699 8.5321 7.46999C8.8251 7.76299 8.8251 8.23803 8.5321 8.53103L5.81213 11.251H20.0001C20.4141 11.25 20.7501 11.586 20.7501 12Z" fill="black" />
                                </svg>
                            </button>
                            <div className="flex items-center gap-[10px]">
                                <div className="w-[45px] h-[45px] rounded-full flex items-center justify-center bg-gray-200 cursor-pointer">
                                    <h1 className="text-black font-bold text-[22px]">{String(Location.state.name.slice(0, 1)).toUpperCase()}</h1>
                                </div>
                                <h1 className="font-medium text-[17px]">{Location.state.name}</h1>
                            </div>
                        </div>
                    </div>

                    <div ref={chatBoxBodyRef} className="h-full bg-white shadow mt-[10px] p-[10px] rounded-[10px] scroll_container">
                        {allChat.length >= 1
                            ? <div className="flex flex-col flex-grow-1">
                                {allChat?.map((item, index) => {
                                    return <ChatList key={index} item={item} index={index} chatlist={allChat} handleTimeFormat={handleTimeFormat} />
                                })}
                            </div> : <div className="h-full flex items-center justify-center">
                                <h1 className='font-medium text-[20px] text-gray-600'>Start Conversation...</h1>
                            </div>}
                    </div>

                    <div className="bg-white shadow my-[10px] p-[10px] rounded-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <input type="text" onKeyDown={(e) => handleKeyDown(e)} value={input} onChange={(e) => setInput(e.target.value)} className="w-full px-[15px] py-[8px] rounded-[10px] border-[2px]" placeholder={`Message ${Location.state.name}`} />
                            <button onClick={handleSendMessage} className="bg-[--bgcolor] p-[9px] rounded-[10px]">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9271 3.07299C20.2251 2.37099 19.231 2.095 18.265 2.336L5.15221 5.61401C3.40421 6.05101 2.23808 7.55499 2.25108 9.35699C2.26408 11.159 3.45021 12.646 5.20421 13.059L9.85021 14.152L10.9432 18.797C11.3562 20.551 12.8431 21.737 14.6451 21.75C14.6541 21.75 14.6642 21.75 14.6732 21.75C16.4622 21.75 17.9521 20.587 18.3871 18.849L21.6651 5.73599C21.9051 4.77099 21.6301 3.77599 20.9271 3.07299ZM20.2091 5.37201L16.931 18.485C16.602 19.798 15.5412 20.258 14.6542 20.25C13.8092 20.244 12.7132 19.77 12.4032 18.454L11.2992 13.763L15.5301 9.531C15.8231 9.238 15.8231 8.763 15.5301 8.47C15.2371 8.177 14.7621 8.177 14.4691 8.47L10.2372 12.702L5.54601 11.598C4.22901 11.288 3.75513 10.191 3.74913 9.346C3.74313 8.50101 4.20202 7.397 5.51402 7.069L18.6271 3.79098C18.7341 3.76398 18.8421 3.751 18.9481 3.751C19.2881 3.751 19.6161 3.885 19.8651 4.134C20.1921 4.46 20.3211 4.92301 20.2091 5.37201Z" fill="white"></path></svg>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Chat;


const ChatList = ({ item, index, chatlist, handleTimeFormat }) => {

    const ItsMe = item.status == "1";

    const msgDate = dayjs(item.timestamp?.toDate()).format("YYYY-MM-DD");

    let prevDate = null;
    
    if (index > 0) {
        prevDate = dayjs(chatlist[index - 1].timestamp?.toDate()).format("YYYY-MM-DD");
    }

    const showDateHeader = msgDate !== prevDate;

    const today = dayjs().format("YYYY-MM-DD");
    const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

    let dateLabel = "";

    if (msgDate === today) dateLabel = "Today";
    else if (msgDate === yesterday) dateLabel = "Yesterday";
    else dateLabel = dayjs(item.timestamp?.toDate()).format("D MMM YYYY");

    return <div key={index} className={`${ItsMe ? "text-end" : "text-start"}`}>
        {showDateHeader && (
            <div className="date_header text-center text-black my-3 font-medium text-[16px]">
                {dateLabel}
            </div>
        )}
        <div style={{ borderRadius: ItsMe ? "10px 10px 0 10px" : "10px 10px 10px 0px" }} className={`message ${index !== 0 ? "mt-[10px]" : "mt-0"} ${ItsMe ? "bg-[--bgcolor] text-white" : "bg-gray-200 text-black"}`}>
            <p className='font-medium text-[15px] whitespace-pre-line text-start'>
                {item.message}
            </p>
            <p className='text-[13px] mt-[3px]'>{handleTimeFormat(item.formattedTime)}</p>
        </div>
    </div>

}
/* jshint ignore:end */